import axios from "axios";
import { toast } from "react-toastify";
import { GET_TBS_DEAL } from "../../../Store/Type";


const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});


const apiUrl = process.env.REACT_APP_API_URL;

export const TbsPercentage=async(dispatch)=>{
    try {
    const response = await axios.get(`${apiUrl}/getall/tbsdeal/percentage`);
      console.log(response.data, "tbspercentage");
      dispatch({
          type: GET_TBS_DEAL,
          payload: response.data,
      });
  } catch (err) {
      console.log(err);
  }

}

export const TbsDealPercentageById= async (editId) => {
 try {
    const response = await axios.get(
      `${apiUrl}/getbyid/tbsdeal/percentage/${editId}`,
      
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
    
    
  } catch (err) {
    handleError(err); 
  }
};


export const TbsupdateData = async (fetchData,editId,values,dispatch) => {
  const userId=sessionStorage.getItem("USER_ID");
  const payload = {
    percentage: values.percentage,
    from_date: values.from_date,
    to_date: values.to_date,
    user_id:userId,
  };
  const url=fetchData?`${apiUrl}/update/tbsdeal/percentage/${editId}`:`${apiUrl}/add/tbsdeal/percentage` 
  const method = fetchData?"put": "post";
  
  try {
    const response = await api({
      method,
      url,
      data:JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    });
    TbsPercentage(dispatch);
    toast.success(response.data.message)
    return response?.data
  } catch (error) {
    console.error('Error:', error);
  }
};





export const Deleteall = async (
  api,
  module,
  
) => {
  try {
    const response = await axios.delete(api);
    console.log(module === "tbsDeal", "responsedata5555");
    toast.success(response.data);
    
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};



const handleError = (error) => {
  console.error("Error details:", error);
  let errorMessage = "An error occurred";

  if (error.response) {
    console.error("Error response from server:", error.response);
    errorMessage = `Server responded with status ${error.response.status}`;
  } else if (error.request) {
    console.error("No response received:", error.request);
    errorMessage = "No response received from server";
  } else {
    console.error("Error setting up request:", error.message);
    errorMessage = error.message;
  }

  if (error.code === "ERR_NETWORK") {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }
  if (error.code === "ERR_CONNECTION_REFUSED") {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }
  toast.error(errorMessage);
};